import React from "react";
import "./QuestionItem.css";
import { PronunciationButton } from "../common/PronunciationButton";
import { WordSelectionItem } from "../../types/game";

// 定义QuestionItem的Props接口
interface QuestionItemProps {
  question: WordSelectionItem;
  index: number;
  selectedOptions: {
    [key: number]: string;
  };
  submittedAnswers: boolean;
  onSelectOption: (index: number, option: string) => void;
}

/**
 * 问题项组件 - 显示单个问题、发音按钮和选项
 */
export const QuestionItem: React.FC<QuestionItemProps> = ({
  question,
  index,
  selectedOptions,
  submittedAnswers,
  onSelectOption,
}) => {
  const options = question.options;
  return (
    <div
      className={`question-item ${
        !selectedOptions[index] && submittedAnswers ? "question-item-error" : ""
      }`}
      data-index={index}
    >
      <p className="question-word">{question.word}</p>
      <PronunciationButton word={question.word} />
      <div className="options-container">
        {options.map((opt, optIndex) => {
          const isSelected = selectedOptions[index] === opt;
          const isCorrect = opt === question.correctAnswer;
          const isWrong = submittedAnswers && isSelected && !isCorrect;

          return (
            <button
              className={`option-btn ${isSelected ? "selected" : ""} ${
                submittedAnswers && isCorrect ? "correct-answer" : ""
              } ${isWrong ? "wrong-answer" : ""}`}
              data-question={index}
              data-value={opt}
              onClick={() => onSelectOption(index, opt)}
              key={optIndex}
              disabled={submittedAnswers}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};

/**
 * 问题列表组件 - 显示多个问题项
 */
interface QuestionListProps {
  questionsWithOptions: {
    question: WordSelectionItem;
    options: string[];
  }[];
  selectedOptions: {
    [key: number]: string;
  };
  submittedAnswers: boolean;
  handleOptionClick: (questionIndex: number, optionValue: string) => void;
}

export const QuestionList: React.FC<QuestionListProps> = ({
  questionsWithOptions,
  selectedOptions,
  submittedAnswers,
  handleOptionClick,
}) => {
  return (
    <>
      {questionsWithOptions.map(({ question, options }, index) => (
        <QuestionItem
          key={index}
          question={question}
          index={index}
          selectedOptions={selectedOptions}
          submittedAnswers={submittedAnswers}
          onSelectOption={handleOptionClick}
        />
      ))}
    </>
  );
};
